import { gql } from "apollo-boost";

// export const ADD_UPDATE_ATHLETE = gql`
//   mutation athleteAddUpdate(
//     $athleteId: ID!
//     $firstName: String
//     $lastName: String
//     $birthDate: String!
//     $photo: String
//     $gender: String
//     $status: String
//     $email: String!
//     $language: String
//     $country: String
//     $createDate: String!
//     $updateDate: DateTime!
//     $updateSource: String!
//     $phone: String
//     $sourceOfInformation: String
//     $homeAddress: String
//     $postalCode: String
//     $occupation: String
//     $additionalInfo: String
//     $clubId: Int
//     $teamId: Int
//     $startMembership: String!
//     $endMembership: String
//     $formsSigned: String
//   ) {
//     athleteAddUpdate(
//       athleteId: $athleteId
//       firstName: $firstName
//       lastName: $lastName
//       birthDate: $birthDate
//       photo: $photo
//       gender: $gender
//       status: $status
//       email: $email
//       language: $language
//       country: $country
//       createDate: $createDate
//       updateDate: $updateDate
//       updateSource: $updateSource
//       phone: $phone
//       sourceOfInformation: $sourceOfInformation
//       homeAddress: $homeAddress
//       postalCode: $postalCode
//       occupation: $occupation
//       additionalInfo: $additionalInfo
//       clubId: $clubId
//       teamId: $teamId
//       startMembership: $startMembership
//       endMembership: $endMembership
//       formsSigned: $formsSigned
//     ) {
//       athleteId
//       firstName
//       lastName
//       birthDate
//       photo
//       gender
//       status
//       email
//       language
//       country
//       createDate
//       updateDate
//       updateSource
//       phone
//       sourceOfInformation
//       homeAddress
//       postalCode
//       occupation
//       additionalInfo
//       clubId
//       teamId
//       startMembership
//       endMembership
//       formsSigned
//     }
//   }
// `;

export const ADD_UPDATE_ATHLETE = gql`
  mutation athleteAddUpdate($athleteData: AthleteInputNew!) {
    athleteAddUpdate(athleteData: $athleteData) {
      edges {
        node {
          personId
          firstName
          lastName
          birthDate
          photo
          gender
          email
          language
          country
          createDate
          updateDate
          updateSource
          phone
          sourceOfInformation
          homeAddress
          postalCode
          occupation
          clubPersonRels {
            edges {
              node {
                seqNo
                clubId
                personId
                role
                teamId
                startMembership
                endMembership
                formsSigned
                participationDays
                volunteerHours
                tryoutDatetime
                status
                additionalInfo
                updateDate
                updateSource
              }
            }
          }
        }
      }
    }
  }
`;
// export const ADD_UPDATE_ATHLETE = gql`
//   mutation athleteAddUpdate($athleteData: AthleteInput!) {
//     athleteAddUpdate(athleteData: $athleteData) {
//       edges {
//         node {
//           personId
//           firstName
//           lastName
//           birthDate
//           photo
//           gender
//           email
//           language
//           country
//           createDate
//           updateDate
//           updateSource
//           phone
//           sourceOfInformation
//           homeAddress
//           postalCode
//           occupation
//           status
//           additionalInfo
//           clubPersonRels {
//             edges {
//               node {
//                 seqNo
//                 clubId
//                 personId
//                 personRelationship
//                 teamId
//                 startMembership
//                 endMembership
//                 formsSigned
//                 updateDate
//                 updateSource
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `;

// mutation m7 {
//   athleteAddUpdate(athleteData:{

//     firstName:"testname",
//     lastName:"testlastname",
//     birthDate:"2000-12-01",
//     photo:"testphoto",
//     gender:"male",
//     email:"testemail@mail.com",
//     language:"EN",
//     country:"testCountry",
//     phone:"testPhone",
//     sourceOfInformation:"Facebook",
//     homeAddress:"testAddress",
//     postalCode:"testCode",
//     occupation:"testOccupation",
//     status:"Active",
//     additionalInfo:"testAdditionalInfo",
//     clubId:1,
//     teamId:43
//     startMembership:"2024-01-01",
//     endMembership:"2024-12-01",
//     formsSigned:"TO DO: T,M,W,P",
//     updateSource:"testSource"
//   }){
//     edges{
//       node{
//        personId
//         firstName
//         lastName
//         birthDate
//         photo
//         gender
//         email
//         language
//         country
//         createDate
//         updateDate
//         updateSource
//         phone
//         sourceOfInformation
//         homeAddress
//         postalCode
//         occupation,
//         status,
//         additionalInfo,
//         clubPersonRels{
//           edges{
//             node{
//                seqNo
//                clubId
//                personId
//                personRelationship
//                teamId
//                startMembership
//                endMembership
//                formsSigned
//                updateDate
//                updateSource
//             }
//           }
//         }
//       }
//     }
//   }
// }

export const ADD_ATHLETE = gql`
  mutation MutateAthlete(
    $athleteId: Int
    $firstName: String!
    $lastName: String!
    $status: String!
    $birthDate: Date!
    $photo: String
    $gender: String!
    $email: String!
    $language: String
    $country: String
    $createDate: Date
    $athleteCode: String
    $athleteCodeType: String
    $updateSource: String!
    $teamId: Int!
  ) {
    athleteMerge(
      athleteData: {
        athleteId: $athleteId
        firstName: $firstName
        lastName: $lastName
        status: $status
        birthDate: $birthDate
        photo: $photo
        gender: $gender
        email: $email
        language: $language
        country: $country
        createDate: $createDate
        athleteCode: $athleteCode
        athleteCodeType: $athleteCodeType
        updateSource: $updateSource
        teamId: $teamId
      }
    ) {
      node {
        athleteId
        firstName
        lastName
        status
        birthDate
        photo
        gender
        email
        language
        country
        createDate
        updateSource
        teamId
      }
    }
  }
`;

export const ADD_ATHLETE_PERSON = gql`
 mutation athleteAddUpdate($personId: Int,$firstName: String!, $lastName: String!, $birthDate: Date!, $photo: String, $gender: String!, $email: String!, $language: String, $country: String, $createDate: Date, $updateSource: String!, $phone: String, $sourceOfInformation: String, $homeAddress: String, $postalCode: String, $occupation: String, $status: String!, $additionalInfo: String, $seqNo: Int, $clubId: Int!, $teamId: Int, $startMembership: Date!, $endMembership: Date, $formsSigned: String, $participationDays: String, $volunteerHours: Int, $tryoutDatetime: DateTime ) {
  athleteAddUpdate(athleteData: {personId: $personId,firstName: $firstName, lastName: $lastName, birthDate: $birthDate, photo: $photo, gender: $gender, email: $email, language: $language, country: $country, createDate: $createDate, updateSource: $updateSource, phone: $phone, sourceOfInformation: $sourceOfInformation, homeAddress: $homeAddress, postalCode: $postalCode, occupation: $occupation, status: $status, additionalInfo: $additionalInfo, seqNo: $seqNo, clubId: $clubId, teamId: $teamId, startMembership: $startMembership, endMembership: $endMembership, formsSigned: $formsSigned, participationDays: $participationDays, volunteerHours: $volunteerHours, tryoutDatetime: $tryoutDatetime}) {
edges {
      node {
        personId
        firstName
        lastName
        birthDate
        photo
        gender
        email
        language
        country
        createDate
        updateDate
        updateSource
        phone
        sourceOfInformation
        homeAddress
        postalCode
        occupation
        clubPersonRels {
          edges {
            node {
              seqNo
              clubId
              personId
              role
              teamId
              startMembership
              endMembership
              formsSigned
              participationDays              
              tryoutDatetime
              volunteerHours
              status
              additionalInfo
              updateDate
              updateSource
            }
          }
        }
      }
    }
  }
}
`;

export const DEL_ATHLETE = gql`
  mutation PersonDelete($personId: Int!) {
    personDelete(personId: $personId) {
      status
    }
  }
`;

export const RESULT_MERGE = gql`
  mutation ResultMerge(
    $resultId: Int
    $setLibSetId: Int!
    $athleteId: Int!
    $setId: Int
    $resultTime: String!
    $resultDate: Date!
    $comments: String
    $isOfficial: Int
    $pulse: Int
    $place: Int
    $facilityType: String
    $meetId: Int
    $updateSource: String!
  ) {
    resultMerge(
      resultData: {
        resultId: $resultId
        setLibSetId: $setLibSetId
        athleteId: $athleteId
        setId: $setId
        resultTime: $resultTime
        resultDate: $resultDate
        comments: $comments
        isOfficial: $isOfficial
        pulse: $pulse
        place: $place
        facilityType: $facilityType
        meetId: $meetId
        updateSource: $updateSource
      }
    ) {
      node {
        resultId
        setLibSetId
        athleteId
        setId
        resultTime
        resultDate
        comments
        isOfficial
        pulse
        place
        facilityType
        meetId
        updateSource
      }
    }
  }
`;

export const RESULT_DELETE = gql`
  mutation resultDelete($resultId: Int!) {
    resultDelete(resultId: $resultId) {
      status
    }
  }
`;



export const PERSON_COMMUNICATIONS_MUTATE = gql`
  mutation PersonCommunicationsMutate(
        $seqNo: Int
        $leadId: Int
        $communicationType: String!
        $communicationResource: String
        $subject: String!
        $details: String!
        $communicationDate: String!
        $followUpDate: String
        $followUpStatus: String
        $updateSource: String!
  ) {
    personCommunicationsMutate(
      programData: {
        seqNo: $seqNo
        leadId: $leadId
        communicationType: $communicationType
        communicationResource: $communicationResource
        subject: $subject
        details: $details
        communicationDate: $communicationDate
        followUpDate: $followUpDate
        followUpStatus: $followUpStatus
        updateSource: $updateSource
      }
    ) {
      edges{
      node {
        seqNo
        leadId
        communicationType
        communicationResource
        subject
        details
        communicationDate
        followUpDate
        followUpStatus
        updateSource
      }
    }
  }  
  }`;

export const PERSON_COMMUNICATIONS_DELETE = gql`
  mutation personCommunicationsDelete($seqNo: Int!) {
    personCommunicationsDelete(seqNo: $seqNo) {
      success
      message
    }
  }`;

export const CLUB_PERSON_REL_MERGE = gql`
  mutation MergeClubPersonRel(
    $seqNo: Int
    $clubId: Int
    $personId: Int
    $role: String
    $teamId: Int
    $eventId: Int
    $startMembership: String
    $endMembership: String
    $formsSigned: String
    $participationDays: String
    $volunteerHours: Int
    $tryoutDatetime: String
    $status: String
    $additionalInfo: String
    $updateSource: String!
  ) {
    clubPersonRelMerge(
      programData: {
        seqNo: $seqNo
        clubId: $clubId
        personId: $personId
        role: $role
        teamId: $teamId
        eventId: $eventId
        startMembership: $startMembership
        endMembership: $endMembership
        formsSigned: $formsSigned
        participationDays: $participationDays
        volunteerHours: $volunteerHours
        tryoutDatetime: $tryoutDatetime
        status: $status
        additionalInfo: $additionalInfo
        updateSource: $updateSource
      }
    ) {
      edges {
        node {
          seqNo
          clubId
          personId
          role
          teamId
          eventId
          startMembership
          endMembership
          formsSigned
          participationDays
          volunteerHours
          tryoutDatetime
          status
          additionalInfo
          updateDate
          updateSource
        }
      }
    }
  }
`;

export const CLUB_PERSON_REL_DELETE = gql`
  mutation clubPersonRelDelete($seqNo: Int!) {
    clubPersonRelDelete(seqNo: $seqNo) {
      success
      message
    }
  }`;